/* =============================================
   KYO CUSTOM JS
   ============================================= */

/* --- 1. Formato de precios: eliminar decimales .00 --- */
(function() {
  var running = false;

  function walkTextNodes(el, fn) {
    el.childNodes.forEach(function(node) {
      if (node.nodeType === 3) {
        fn(node);
      } else if (node.nodeType === 1) {
        walkTextNodes(node, fn);
      }
    });
  }

  function formatPrices() {
    if (running) return;
    running = true;

    var priceEls = document.querySelectorAll(
      'product-price, .price__regular, .price__sale, .price, .compare-at-price, ' +
      '.price-item, [data-price], .cart-item__price, .totals__total-value, .order-summary__emphasis'
    );

    priceEls.forEach(function(el) {
      walkTextNodes(el, function(node) {
        var original = node.textContent;
        var updated = original.replace(/\.00\b/g, '');
        if (updated !== original) {
          node.textContent = updated;
        }
      });
    });

    running = false;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatPrices);
  } else {
    formatPrices();
  }

  var debounceTimer;
  var observer = new MutationObserver(function() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(formatPrices, 150);
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();


/* --- 2. Selector de idioma → navegar a URL de mercado --- */
/* Al cambiar idioma: EN → /en-us/  |  ES → / (raíz)      */
/* Esto cambia idioma Y moneda al mismo tiempo.             */
(function() {
  'use strict';

  document.addEventListener('change', function(e) {
    var target = e.target;
    if (!target || target.tagName !== 'SELECT' || target.name !== 'language_code') return;

    // Captura antes de que el componente Atelier procese el evento
    e.stopPropagation();
    e.preventDefault();

    var lang = target.value;
    var path = window.location.pathname;
    var search = window.location.search;

    // Quitar cualquier prefijo de mercado existente
    var cleanPath = path.replace(/^\/en-us/, '') || '/';

    if (lang === 'en') {
      // Mercado US: /en-us/ → inglés + USD
      window.location.assign('/en-us' + cleanPath + search);
    } else {
      // Mercado MX (raíz): español + MXN
      window.location.assign(cleanPath + search);
    }

  }, true); // fase capture: se ejecuta ANTES que el handler del componente

})();
